import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { ComponentProps, useCallback } from 'react';
import { DestroyRealmsModal } from 'SandboxModule/components/DestroyRealmsModal';

export const useDestroyRealmsModal = () => {
  const { openModal } = useDynamicModal();

  const openDestroyRealmsModal = useCallback(
    (args: Omit<ComponentProps<typeof DestroyRealmsModal>, 'onClose'>) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return <DestroyRealmsModal onClose={toggle} {...args} />;
        },
      });
    },
    [openModal],
  );

  return {
    openDestroyRealmsModal,
  };
};
